"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var AppleSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M13.2209918,14.4307929 C12.5135341,15.1173662 11.7329812,15.0103339 10.988976,14.6866263 C10.1979809,14.3563924 9.47485997,14.335508 8.63948564,14.6866263 C7.59918354,15.13564 7.04705331,15.0051128 6.42052256,14.4307929 C2.88323437,10.7890829 3.40534333,5.24167524 7.42558231,5.03283166 C8.40062079,5.08504256 9.08327825,5.57190916 9.65759811,5.6123726 C10.5112463,5.43877137 11.3283468,4.94146259 12.2420375,5.00672621 C13.3397715,5.09548473 14.1607879,5.52883517 14.7090023,6.30808279 C12.450881,7.66556608 12.9860427,10.6415871 15.0601206,11.4769615 C14.6450439,12.5668639 14.1124928,13.6437137 13.2196865,14.4399298 L13.2209918,14.4307929 Z M9.57928176,4.99367349 C9.4735547,3.37513572 10.7853535,2.04375787 12.2942483,1.91323063 C12.5017867,3.77977016 10.5973942,5.17641162 9.57928176,4.99367349 Z" })));
};
AppleSmall.displayName = 'AppleSmall';
exports.default = AppleSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=AppleSmall.js.map